import React, { useEffect, useRef, useState } from "react";
import {  useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import moment from "moment";
import randomColor from "randomcolor";
import { TrimText } from "../common/TrimText";
import { formatOnlyDateRange, getSubjectStatus, subjectDuration } from "../../utils/commonFunction";
import ViewProfile from "../course/ViewProfile";
import { buildStatusChip, markChipStyle, headerColor,GetLearningMethodText, GetCampusText } from "./ProgramHelperUtils.js";
import { programStyles } from "./ProgramStyles";
import MarkChip from "./markChip";
import { tokens } from "../../public/tokens.js";
import { ReactComponent as Logo } from "../../assets/images_1/aieLogoIcon.svg";
import SkeletonQualification from "../../loaders/SkeletonQualification"; 

export default function SubjectGroupList({
  subjectList,
  qualification,
  qid,
  completed_subject,
  showSideBar,
  setShowSideBar,
  loading,
  lockGrades
}) {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isWithHeldStatus = localStorage.getItem("resultWithHeld");
  const lockedGrades = lockGrades

  const [color, setColor] = useState(null);
  const popRef = useRef(null)
  useEffect(() => {
    setColor(
      randomColor({
        luminosity: "dark",
      })
    );
  }, [qualification]);

  useEffect(() => {
    if (window.innerWidth < 769) {
      setShowSideBar(false)
    } else {
      setShowSideBar(true)
    }
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [showSideBar]);

  const getTextLength = () => {
    if (windowWidth < 321) {
      return 76;
    }

    if (windowWidth < 376) {
      return 90;
    }

    if (windowWidth < 426) {
      return 110;
    }

    if (windowWidth < 769) {
      return 90;
    }

    if (windowWidth < 1025) {
      return showSideBar ? 80 : 135;
    }

    if (windowWidth < 1442) {
      return showSideBar ? 145 : 200;
    }

    if (windowWidth < 1920) {
      return showSideBar ? 180 : 230;
    }

    if (windowWidth < 2560) {
      return showSideBar ? 235 : 350;
    }

    return 235
  };

  if (loading) {
    return (
      <div>
        <SkeletonQualification />
      </div>
    );
  }

  return (
    <>

      <div className="moduleCardContainer" style={programStyles.moduleCards}>

        {subjectList?.map((ele, i) => {
          const isForcedFinished = ele.subjectStatus === "Finished" || ele.show_results === 1;          
          const chip = buildStatusChip(
            (isForcedFinished ? "Finished" : ele.subjectStatus),
            isWithHeldStatus == "true" ? "witheld" : ele.show_results === 1 ? ele?.studentResult?.pass_status : "");
          const hasCode = !!ele?.code;
          const hasIntake = !!(ele?.number && ele?.year);
          const isUpcoming = ele?.subjectStatus === "Not Yet Published";
          const assessment = ele?.progress?.totalAssessmentPercentage || 0;
          const learning = ele?.progress?.totalLearningMaterialPercentage || 0;
          const assessmentOnTop = assessment < learning;
          
          return (
            <Link
              to={`/course/${qid}/subject/${ele?.intake_id}`}
              style={{
                ...programStyles.moduleCard,
                ...(isUpcoming ? programStyles.upcomingCard : {}),
              }}
              
              key={ele.intake_id}
              title={ele?.name}
              onClick={(e) => {
                if (ele?.subjectStatus === "Not Yet Published") {
                  e.preventDefault();
                }
              }}
              ref={popRef}
            >

              <div
                style={{
                  ...programStyles.moduleCardHeader,

                  ...headerColor((isForcedFinished ? "Finished" : ele.subjectStatus),
                  isWithHeldStatus == "true" ? "witheld" : ele.show_results === 1 ? ele?.studentResult?.pass_status : "")
                }}
              >
                <div style={programStyles.svgLayer}>
                  <Logo/>
                </div>
                <div style={programStyles.statusRow}>
                  <div style={programStyles.statusLeft}>
                    <span style={{ ...programStyles.chipBase, ...chip.style }}>
                      {chip.label}
                    </span>
                    {(hasCode || hasIntake) && (
                      <span style={programStyles.codeIntake}>
                        {hasCode && ele.code}
                        {hasCode && hasIntake && " | "}
                        {hasIntake && (
                          <>Intake {ele.number}, {ele.year}</>
                        )}
                      </span>
                    )}
                  </div>
                  {isForcedFinished && ele.show_results === 1 &&
                    ele?.studentResult?.pass_status !== "witheld" && (
                      <div>
                        <MarkChip
                          passed={ele?.studentResult?.pass_status}
                          mark={ele?.studentResult?.gradeText}
                        />
                      </div>
                    )}
                </div>
                <div style={programStyles.headerBottom}>
                    <div style={programStyles.titleRow}>
                      {/* {ele?.name ? TrimText(ele?.name, 50) : ""} */}
                      {ele?.name}
                    </div>
                    <div style={programStyles.dateRow}>
                      <i className="fa-light fa-calendar-clock"></i>
                      {ele?.start && ele?.end
                        ? formatOnlyDateRange(ele?.start, ele?.end) 
                        : "Invalid Date"}
                      {(ele?.type || ele?.campus) && (
                        <>
                          <i className="fa-light fa-building-columns" />
                          {ele?.type && GetLearningMethodText(ele.type)}
                          {ele?.type && ele?.campus ? " - " : ""}
                          {ele?.campus && GetCampusText(ele.campus)}
                        </>
                      )}
                  </div>
                </div>
              </div>
              <div style={programStyles.progressSection}>
                <div style={programStyles.progressWrapper}>
                  <div style={programStyles.progressTrack}>
                    <div
                      style={{
                        ...(assessmentOnTop
                          ? programStyles.progressFillLearning
                          : programStyles.progressFillAssessment),
                        width: `${Math.max(assessment, learning)}%`,
                      }}
                    />
                    <div
                      style={{
                        ...(assessmentOnTop
                          ? programStyles.progressFillAssessment
                          : programStyles.progressFillLearning),
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: `${Math.min(assessment, learning)}%`,
                      }}
                    />
                  </div>
                  <div style={programStyles.progressFooter}>
                    <span style={programStyles.totalProgressText}>
                        {(ele?.progress?.progressBar ?? 0)}% Complete
                      </span>
                      <div style={programStyles.legendRow}>

                        <div style={programStyles.legendItem}>
                          <span
                            style={{
                              ...programStyles.dot,
                              backgroundColor: tokens.colors.brand["fresh-green"]["700"],
                            }}
                          />
                          Assessments
                        </div>
                        <div style={programStyles.legendItem}>
                          <span
                            style={{
                              ...programStyles.dot,
                              backgroundColor: tokens.colors.brand["fresh-green"]["400"],
                            }}
                          />
                          Learning Material
                        </div>
                      </div>
                    </div>
                  </div>
                </div>              
            </Link>
          );
        })}
      </div>
    </>
  );
}
